
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/automobile-insurance/physical-damage-guide",
      function () {
        return require("private-next-pages/compliance/automobile-insurance/physical-damage-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/automobile-insurance/physical-damage-guide"])
      });
    }
  